import {
    StyleSheet
} from "react-native";
import type {
    SidebarMeasures,
    SidebarVariant
} from "../../type";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        flexDirection: "column",
        borderStyle: "solid",
        flexShrink: 0,
        minWidth: 0
    }
});

export const useStyles = ({
    isScrolled,
    measures,
    borders,
    variant,
    colors,
    spaces
}: {
    colors: NCoreUIKit.ActivePalette["colors"];
    spaces: NCoreUIKit.ActivePalette["spaces"];
    borders: NCoreUIKit.Borders;
    measures: SidebarMeasures;
    variant: SidebarVariant;
    isScrolled: boolean;
}) => {
    return {
        container: {
            paddingVertical: variant === "floating" ? measures.padding : spaces.spacingSm,
            borderBottomColor: isScrolled ? colors.content.border.subtle : "transparent",
            borderBottomWidth: borders.separator,
            paddingHorizontal: measures.padding,
            minHeight: measures.headerHeight,
            gap: spaces.spacingSm
        }
    };
};
export default stylesheet;
